import { createHttpLink } from '@apollo/client/link/http';
import { ApolloClient, from, InMemoryCache } from '@apollo/client';
import { toastErrorLink } from './graphql-error';

const httpLink = createHttpLink({
  uri: __JS_ENV_VARS__['JS_ENV_CMS_GRAPHQL_URL'],
});

export const cmsGraphql = new ApolloClient({
  link: from([toastErrorLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
});
